import Vue from 'vue'
import Vuex from 'vuex'

import miSeleccion from '@/store/modules/miSeleccion'
import userHash from '@/store/modules/userHash'

import axios from 'axios'

Vue.use(Vuex);

let jsSessionCheck
let userProfile

if (typeof user_profile !== 'undefined') {
  jsSessionCheck = (user_profile == 'bibl' || user_profile == 'admin' || user_profile == 'badmin') ? true : false; 
  userProfile = user_profile
}else{
  userProfile = 'Default'
  jsSessionCheck = false
}
const username = ( typeof nombreUsuario !== 'undefined' ) ? nombreUsuario : ''; 

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
	modules:{
		miSeleccion,
		userHash
	},
	state: {
		menuState: '',
		paginacionN: 4,	// Before and after actualpage => range
		defaultResultsPerPage: 50,
		optionsResultsPerPage: [20,50,100],
		showLogin: false,
		loggedIn: jsSessionCheck,	
		//loggedIn: true,
		//apiURL: "http://192.168.1.200/tatarana/api/",
		apiURL: process.env.VUE_APP_API_URL,
		reloadContent: false,
		//searchResult: [],
		fichaExtendidaSelected: false,
		maxElementosContenedor: 15,
		selectionBus: {},
		pasoCompra: 1,
		/* username: username, // Definido por api.js y por el login
		userRole: userProfile, // Definido por api.js y por el login */
		username: '',
		userRole: '',
		locale: null,
		sustitucionesCantidades: {
			pendientes: 0,
			sinPropuestas: 0,
			rechazados: 0,
			aceptados: 0
		}
	},
	getters:{
		menuState: state => {
			if ( state.route.params.category ){
				return {
					idioma: (state.route.params.language) ? state.route.params.language : state.locale,
					categoria: state.route.params.category,
					subCategoria: state.route.query.expandido
				}
			}else{
				return 'Home';
			} 
		},
		getSearchTerms: state => {
			return {
				idioma: (state.route.params.language) ? state.route.params.language : state.locale,
				categoria: state.route.params.category,
				query: state.route.query
				}	
		},
		getApiUrl: state => { return state.apiURL },
		getLocale: state => { return (state.route.params.language) ? state.route.params.language : state.locale
			
			/*return state.locale  return state.route.params.language */ },
		getCategory: state => { return state.route.params.category; },
		getMiPedidoTipo: state => { return state.route.params.tipo },
		getPath: state => { return state.route.path },
		getReloadContent: state => { return state.reloadContent },
		getSearchResult: state => { return state.searchResult },
		getMaxElementosContenedor: state => { return state.maxElementosContenedor; },
		getPasoCompra:  state => { return state.pasoCompra; },
		getUsername: state => { return state.username; },
		getUserRole: state => { return state.userRole; },

		// FILTERS
		getActualPage: state => { return (state.route.query.p > 0) ? state.route.query.p : 1; },
		getResultsPerPage: state => { return (state.route.query.rpp > 0) ? state.route.query.rpp : state.defaultResultsPerPage; },
		getQuery: state => { return state.route.query; },
		getN: state => { return state.paginacionN; },
		getOptionsResultsPerPage: state => { return state.optionsResultsPerPage; },

		getModalLogin: state => { return state.showLogin; },
		getLoggedIn: state => { return state.loggedIn; },

		getToken: state => { return state.token; },

		isSearch: state => {
			//alert(JSON.stringify(state.route.query))
			// state.route.query.expandido: Menu con filtro: temáticas, paises, ...
			if( state.route.query.expandido || state.route.query.login ){ return false; }
			else if( Object.keys(state.route.query).length === 0 && state.route.query.constructor === Object){ return false; }
			else{ return true; }
		},
		isFichaExtendidaSelected: state => { return state.fichaExtendidaSelected; },

		getSelectionBus: state => { return state.selectionBus; },

		getTokenRestablecerContrasena: state => { return (state.route.query.token) ? state.route.query.token : false; },

		getRouteLogin: state => { return (state.route.query.login == 'true') ? true : false; },

		getIdConsorcio: state => { return state.route.params.idConsorcio },
		getReferencia: state => { return state.route.params.referencia },

		// Para consorcios misconsultas (cpanel) <-> mis consultas (user), no tiene efecto, 
		getActiveBiblioteca: state => { return null },
		getSustitucionesCantidades: state => { return state.sustitucionesCantidades }
	},
	mutations:{
		showModalLogin: state => { state.showLogin = true; },
		closeModalLogin: state => { state.showLogin = false; },

		setLoggedIn: state => { state.loggedIn = true; },
		setLoggedOut: state => { state.loggedIn = false; },

		setReloadContent: (state, value) => { state.reloadContent = value; },
		setSearchResult: (state, value) => { state.searchResult = value; },

		setFichaExtendidaSelected: (state, value) => { state.fichaExtendidaSelected = value; },

		setSelectionBus: (state, obj) => { 
			// Clear Object
			Object.keys(state.selectionBus).forEach(function(key) { delete state.selectionBus[key]; });
			state.selectionBus = obj;
		},
		setPasoCompra: (state, value) => { state.pasoCompra = value; },
		setUsername: (state, value) => { state.username = value; },
		setUserProfile: (state, value) => { state.userRole = value; },
		setLocale: (state, value) => { state.locale = value; },
		setSustitucionesCantidades: (state, data) => { 
			state.sustitucionesCantidades.pendientes = data.pendientes
			state.sustitucionesCantidades.sinPropuestas = data.sinPropuestas
			state.sustitucionesCantidades.rechazados = data.rechazados
			state.sustitucionesCantidades.aceptados = data.aceptados
		},
		setSustitucionesCantidadesField: (state, data) =>{
			state.sustitucionesCantidades[data.key] = parseInt(state.sustitucionesCantidades[data.key], 10) + parseInt(data.value, 10)
		}
	},
	actions:{
		addToSelection: ( { state, getters, commit }, obj ) => {
			/*var obj = state.searchResult.data.data.resultados.find(function (obj) { return obj.id === id; });
			obj.miseleccion = null;
			state.fichaExtendidaSelected = null;

			axios.post( getters.getApiUrl + getters.getLocale + '/miseleccion/' + id )
      .then( (respuesta) =>{
      	obj.miseleccion = 1;
      	state.fichaExtendidaSelected = true;
      })
      .catch( (error) =>{ 
      	alert(error.response.data.status + ' ' + error.response.data.msg);
  		});*/
			commit('setSelectionBus', { id: obj.id, miseleccion: null } );				
			let contenedor = (obj.con) ? '&con=' + obj.con : '';	// Saber desde que contenedor se ha añadido el objecto a la selección

			axios.post( getters.getApiUrl + getters.getLocale + '/miseleccion/' + obj.id + '?ref=' + obj.ref + '&tipo=' + obj.tipo + contenedor )
      .then( (respuesta) =>{
      	commit('setSelectionBus', { id: obj.id, miseleccion: true } );
      	//state.fichaExtendidaSelected = true;
      })
      .catch( (error) =>{ 
      	alert(error.response.data.status + ' ' + error.response.data.msg);
      	commit('setSelectionBus', { id: obj.id, miseleccion: false } );
  		});
			
		},
		removeFromSelection: ( { state, getters, commit }, id ) => {
			/*var obj = state.searchResult.data.data.resultados.find(function (obj) { return obj.id === id; });
			obj.miseleccion = null;
			state.fichaExtendidaSelected = null;

			axios.delete( getters.getApiUrl + getters.getLocale + '/miseleccion/' + id)
      .then( (respuesta) =>{
      	obj.miseleccion = 0;
      	state.fichaExtendidaSelected = false;
      })
      .catch( (error) =>{ 
      	alert(error.response.data.status + ' ' + error.response.data.msg);
  		});*/
			commit('setSelectionBus', { id: id, miseleccion: null } );			
			axios.delete( getters.getApiUrl + getters.getLocale + '/miseleccion/' + id )
      .then( (respuesta) =>{
      	commit('setSelectionBus', { id: id, miseleccion: false } );
      	//state.fichaExtendidaSelected = true;
      })
      .catch( (error) =>{ 
      	alert(error.response.data.status + ' ' + error.response.data.msg);
      	commit('setSelectionBus', { id: id, miseleccion: true } );
  		});
    }
	}
});

